"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelected = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _Icon = require("../../base-components/Icon/Icon");
var _ClickableElement = require("../../base-components/Button/ClickableElement");
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
var _Link = require("../../base-components/Link/Link");
var _Image = require("../../base-components/Image/Image");
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CardSelected = exports.CardSelected = function CardSelected(_ref) {
  var card = _ref.card,
    CancelIcon = _ref.CancelIcon,
    iconColor = _ref.iconColor,
    namespace = _ref.namespace,
    removeCard = _ref.removeCard,
    linkComponent = _ref.linkComponent;
  var learnMore = card.links.find(function (link) {
    return link.key === 'learnMore';
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "stickyCard card-selected"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-selected__image-container"
  }, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    to: learnMore.url,
    dtm: learnMore.dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'card-art'),
    Component: linkComponent
  }, /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    src: card.cardArtUrl,
    alt: card.cardArtAlt,
    className: "card-art"
  })), /*#__PURE__*/_react["default"].createElement(_ClickableElement.ClickableElement, {
    Component: "div",
    className: "remove-card",
    onClick: function onClick() {
      return removeCard(card);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "remove-card-icon",
    Svg: CancelIcon,
    color: iconColor
  }))), /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: card.cardTitle,
    Component: "p",
    className: "cardText"
  }));
};
CardSelected.propTypes = {
  card: _propTypes["default"].shape({
    assets: _propTypes["default"].arrayOf(_propTypes["default"].object),
    cardTitle: _propTypes["default"].string
  }).isRequired,
  CancelIcon: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  iconColor: _propTypes["default"].string.isRequired,
  namespace: _propTypes["default"].string,
  removeCard: _propTypes["default"].func.isRequired,
  linkComponent: _propTypes["default"].func
};
CardSelected.defaultProps = {
  CancelIcon: function CancelIcon() {
    return (0, _svgFetcher["default"])('axp-icon-cancelcircle', 'us-consumer');
  },
  namespace: '',
  linkComponent: undefined
};